export default "__VITE_ASSET__Cu6Ff1Us__"